// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Figures */
figure.image--large {
  position: relative;

  &:before {
    content: 'XL';
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 8px;
    left: 8px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #2196f3;
    color: white;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    font-weight: 600;
    font-family: system-ui, sans-serif;
    letter-spacing: 0.05em;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }
}

figure.image--bordered {
  & img {
    border: 2px solid #2196f3;
    box-sizing: border-box;
  }
}

/* Custom Heading */
.ck.ck-button.ck-heading_chapter-heading span {
  font-size: 20px;
  font-family: serif;
  font-weight: 700;
}

.ck.ck-button.ck-heading_chapter-label span {
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.06em;
}

.chapter-heading {
  font-size: 21px;
  font-family: serif;
  font-weight: 700;
  max-width: 578px;
  margin: 8px auto 16px;
  padding-top: 24px;
  text-align: center;
  position: relative;

  &:before {
    content: 'Chapter label is missing';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    color: #c91818;
    font-size: 12px;
    background-color: #fee9e9;
    padding: 2px 4px;
    border-radius: 20px;
    display: block;
    font-family: system-ui, sans-serif;
    font-weight: 400;
  }
}

.chapter-label {
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.06em;
  font-family: system-ui, sans-serif;
  text-align: center;
  max-width: 578px;
  margin: 8px auto;
  color: #98a1b3;

  & + .chapter-heading {
    padding-top: 0;
  }

  & + .chapter-heading:before {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,kBAAkB;;EAElB;IACE,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,sBAAsB;IACtB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,sBAAsB;EACxB;AACF;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;;EAElB;IACE,mCAAmC;IACnC,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kCAAkC;IAClC,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;;EAEd;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Figures */\nfigure.image--large {\n  position: relative;\n\n  &:before {\n    content: 'XL';\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: 8px;\n    left: 8px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: #2196f3;\n    color: white;\n    font-size: 12px;\n    line-height: 12px;\n    text-align: center;\n    font-weight: 600;\n    font-family: system-ui, sans-serif;\n    letter-spacing: 0.05em;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  }\n}\n\nfigure.image--bordered {\n  & img {\n    border: 2px solid #2196f3;\n    box-sizing: border-box;\n  }\n}\n\n/* Custom Heading */\n.ck.ck-button.ck-heading_chapter-heading span {\n  font-size: 20px;\n  font-family: serif;\n  font-weight: 700;\n}\n\n.ck.ck-button.ck-heading_chapter-label span {\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.06em;\n}\n\n.chapter-heading {\n  font-size: 21px;\n  font-family: serif;\n  font-weight: 700;\n  max-width: 578px;\n  margin: 8px auto 16px;\n  padding-top: 24px;\n  text-align: center;\n  position: relative;\n\n  &:before {\n    content: 'Chapter label is missing';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    color: #c91818;\n    font-size: 12px;\n    background-color: #fee9e9;\n    padding: 2px 4px;\n    border-radius: 20px;\n    display: block;\n    font-family: system-ui, sans-serif;\n    font-weight: 400;\n  }\n}\n\n.chapter-label {\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.06em;\n  font-family: system-ui, sans-serif;\n  text-align: center;\n  max-width: 578px;\n  margin: 8px auto;\n  color: #98a1b3;\n\n  & + .chapter-heading {\n    padding-top: 0;\n  }\n\n  & + .chapter-heading:before {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
